import { ApiClient } from '@vanialabs/core-api';
import { getSession, logout } from '../auth/authAdapter';

function resolveAccessToken(): string | undefined {
  const session = getSession() as ( {
    accessToken?: string;
    token?: string;
    tokens?: {
      accessToken?: string;
      access?: string;
    };
  } | null);

  return (
    session?.accessToken ??
    session?.token ??
    session?.tokens?.accessToken ??
    session?.tokens?.access
  );
}

export const apiClient = new ApiClient({
  baseUrl:
    import.meta.env.VITE_API_BASE_URL ??
    'http://localhost:8000',

  getAuthToken() {
    return resolveAccessToken();
  },

  onUnauthorized() {
    // Real 401 from the backend (invalid/expired/revoked session):
    // clear the local session and send the user back to /login, same
    // navigation pattern already used by ProtectedSuperAdminRoute's
    // AccessDenied screen.
    logout();
    window.location.replace('/login');
  },

  onRequestError(error, info) {
    console.error(
      '[super-admin api error]',
      info,
      error,
    );
  },
});
